import { OrderTrackingStatus } from '../../../services/order-tracking-service';

export const TrackingStatusTranslations: Record<OrderTrackingStatus, string> = {
	[OrderTrackingStatus.Confirmed]: 'CX_ORDER_STATUS.CONFIRMED',
	[OrderTrackingStatus.Received]: 'CX_ORDER_STATUS.RECEIVED',
	[OrderTrackingStatus.DriverFound]: 'CX_ORDER_STATUS.DRIVER_FOUND',
	[OrderTrackingStatus.FindingDriver]: 'CX_ORDER_STATUS.FINDING_DRIVER',
	[OrderTrackingStatus.WayToPickup]: 'CX_ORDER_STATUS.WAY_TO_PICKUP',
	[OrderTrackingStatus.PickingUp]: 'CX_ORDER_STATUS.PICKING_UP',
	[OrderTrackingStatus.OnPreviousDelivery]: 'CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY',
	[OrderTrackingStatus.WayToDropoff]: 'CX_ORDER_STATUS.WAY_TO_DROPOFF',
	[OrderTrackingStatus.Arrived]: 'CX_ORDER_STATUS.ARRIVED'
};
